import { render } from "./Tabnav.vue?vue&type=template&id=afd08418&scoped=true"
import script from "./Tabnav.vue?vue&type=script&lang=js"
export * from "./Tabnav.vue?vue&type=script&lang=js"

import "./Tabnav.vue?vue&type=style&index=0&id=afd08418&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd08418"]])

export default __exports__